import React from "react"
import ChangeCulture from "./Change-Culture"
import Hcp from "../../pages/cloud-solutions/hcp"
import Aiml from "../../pages/data-science/Aiml"

import Partner from "./Partner"
import Footer from "../_App/Footer"
import Layout from "../_App/layout"
import Navbar from "../_App/Navbar"
import Seo from "../_App/seo"
import { Link } from "gatsby"
import * as Icon from "react-feather"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Service = ({
  seoTitle,
  mainHeading,
  mainPara,
  serviceIcons,
  section2Heading,
  cardItems,
  section2Para,
  caseItems,
  seoDescription,
  keyword,
  clodSolution=false,
  cloudOperatingModal = false,
  dataScience=false,
  className,
}) => {
  return (
    <Layout>
      <Seo title={seoTitle} description={seoDescription} keyword={keyword} />

      <Navbar />
      <div className="services-details-area">
        <div className={`${className}`}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12 services-content">
                <div className="section-title">
                  <h2 className="white-text">{mainHeading}</h2>
                  <div className="bar"></div>
                  <p className="white-text">{mainPara}</p>
                </div>

                <div className="row">
                  {serviceIcons.map(item => (
                    <div className="col-lg-6 col-md-6" key={item.id}>
                      <div className="box">
                        {/* <img src={item.icon} alt={item.name} />  */}
                        
                        <ul style={{margin:"2px",listStyleType:"square"}}>
                          <li>{item.name}
                            </li></ul>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-6 col-md-12 d-block d-lg-none p-0">
                {caseItems.casestudyJson.bannerimage.map((val, index) => {
                  return (
                    <div className="about-image" key={index}>
                      <GatsbyImage
                        image={getImage(val.image)}
                        alt={val.heading}
                        loading="eager"
                        objectPosition="center"
                      />
                    </div>
                  )
                })}
              </div>
            </div>
            <div className="separate d-none d-lg-block"></div>
          </div>
        </div>
      </div>
      <div>
      </div>
      <div className="repair-why-choose-us pt-80 pb-80">
        <div className="container">
          <div className="section-title ">
            <h2 >{section2Heading ? section2Heading : "Featured Services"}</h2>
            <div className="bar"></div>
            <p dangerouslySetInnerHTML={{__html: section2Para}}></p>
          </div>
          <div className="row">
            {cardItems.map(item => (
              <div className="col-lg-4 col-md-6 pb-3" key={item.id}>
                <div className="single-repair-box">
                  <div className="icon">
                    <img src={item.icon} alt="repair icon" />
                  </div>
                  <h3>{item.heading}</h3>
                  <ul className="features-details-list">{item.listItems}</ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {cloudOperatingModal && <ChangeCulture />}
      {clodSolution&&<Hcp/>}
      {dataScience&&<Aiml/>}
      {caseItems.casestudyJson.data.length>1&&<div className="blog-area pt-80 pb-50">
        <div className="container">
          <div className="section-title">
            <h2>Case Studies</h2>
            <div className="bar"></div>
          </div>

          <div className="row">
            {caseItems.casestudyJson.data.map((item, index) => {
              return (
                <div className="col-lg-4 col-md-6" key={index}>
                  <div className="single-blog-post">
                    <Link to={item.slug}>
                      <div className="blog-image">
                        <GatsbyImage
                          image={getImage(item.image)}
                          alt={item.heading}
                        />
                        <div className="date">{item.subheading}</div>
                      </div>
                      <div className="blog-post-content">
                        <div className="blog-heading">
                          <h3>{item.heading}</h3>
                        </div>
                        <p>{item.para.substring(0, 117) + "..."}</p>
                        <Link to={item.slug} className="read-more-btn">
                          Read More <Icon.ArrowRight />
                        </Link>
                      </div>
                    </Link>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>}
      {/* <Partner /> */}
      <Footer />
    </Layout>
  )
}

export default Service
